import { Inject, Pipe, PipeTransform } from '@angular/core';

import { TranslationService } from './translation.service';

@Pipe ({ name: 'translate' })
export class TranslationPipe implements PipeTransform
{
  constructor(@Inject(TranslationService) private translationService) {}

  public transform (key: string, value: string, replacements?: any): string
  {
    if (value === undefined) {
      value = '1';
    }
    return this.translationService.get(key.trim(), value, replacements);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/translation/translation.pipe.ts